import {
  UserIcon,
  BuildingOfficeIcon,
  BriefcaseIcon,
} from "@heroicons/react/20/solid";

const timeline = [
  {
    id: 1,
    target: "Ерөнхий Захирал",
    icon: UserIcon,
    iconBackground: "bg-[#08B3EC]",
  },
  {
    id: 2,
    target: "Захирлын зөвлөх",
    icon: UserIcon,
    iconBackground: "bg-[#08B3EC]",
  },
  {
    id: 3,
    target:
      "Захиргаа хамтын ажиллагааны алба",
    icon: UserIcon,
    iconBackground: "bg-[#08B3EC]",
  },
  {
    id: 4,
    target:
      "Санхүү бүртгэлийн алба",
    icon: UserIcon,
    iconBackground: "bg-[#08B3EC]",
  },
  {
    id: 5,
    target: "Хүүхэд хөгжлийн хэлтэс ",
    icon: BuildingOfficeIcon,
    iconBackground: "bg-[#08B3EC]",
    item: "Хөтөлбөр хэрэгжилтийн алба / Хоол үйлдвэрлэлийн алба / Эрүүл мэнд, үйлчилгээний алба",
  },
  {
    id: 6,
    target: "Нийтлэг үйлчилгээний хэлтэс",
    icon: BuildingOfficeIcon,
    iconBackground: "bg-[#08B3EC]",
    item: "Дулаан үйлдвэрлэлийн алба / Барилга ашиглалт, автын алба / Харуул хамгаалалтын алба",
  }
];

const hr = [
  {
    id: 1,
    target: "Ажлын байр",
    icon: BriefcaseIcon,
    iconBackground: "bg-[#08B3EC]",
    item: "﻿﻿Бүлгийн багш-хөтөлбөрийн удирдагч / Тайзны техникч / Тогооч   / Зөөгч / Ачигч  / Үйлчлэгч / Угаагч",
  },
  {
    id: 2,
    target: "Нийтлэг шаардлага",
    icon: BriefcaseIcon,
    iconBackground: "bg-[#08B3EC]",
    item: " ﻿﻿Мэргэжлийн дагуу сургууль төгссөн. (гэрээт бүлгийн удирдагч-оюутан байж болно) / Нас, хүйс харгалзахгүй (бүлгийн удирдагч-21-26 насны) / Хүүхэдтэй ажиллах хүсэл сонирхолтой / Харилцааны эерэг хандлагатай",
  },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default function HumanResources() {
  return (
    <div className="bg-gray-50 pt-20">
      <main className="mx-auto lg:max-w-7xl">
        <section aria-labelledby="products-heading" className="pb-24 sm:pt-24">
          <div className="flex flex-wrap justify-around h-full">
            <div className="mx-4 md:w-2/5">
              <p className="mb-3 font-extra-bold text-2xl">
                Хүний нөөцийн бүтэц
              </p>
              <div className=" border border-gray-200 rounded-lg pb-24 pt-8 sm:px-6 sm:pt-16 px-2  lg:px-8 bg-white min-h-full">
                <ul role="list" className="-mb-8">
                  {timeline.map((event, eventIdx) => (
                    <li
                      key={event.id}
                      className={event.id > 1 ? "ml-10" : "ml-0"}
                    >
                      <div className="relative pb-8 ">
                        <div className="relative flex space-x-3 items-center">
                          <div>
                            <span
                              className={classNames(
                                event.iconBackground,
                                "h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                              )}
                            >
                              <event.icon
                                className="h-5 w-5 text-white"
                                aria-hidden="true"
                              />
                            </span>
                          </div>
                          <div className="flex min-w-0 flex-1 justify-between space-x-4 ">
                            <div className="items-center">
                              <p className="font-medium text-gray-900 lg:w-96">
                                {event.target}
                              </p>
                            </div>
                          </div>
                        </div>
                        <ul className="ml-20 mt-5l">
                          {event.item?.split("/").map((opt) => (
                            <li key={opt} className="list-disc ">
                              {opt}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="mx-4 mt-5 md:mt-0 md:w-2/5">
              <p className="mb-3 font-extra-bold text-2xl ">
                Нээлттэй ажлын байр
              </p>
              <div className="border border-gray-200 rounded-lg pb-24 pt-8 sm:px-6 sm:pt-16 px-2 lg:max-w-7xl lg:px-8 bg-white min-h-full">
                <ul role="list" className="-mb-8">
                  {hr.map((event, eventIdx) => (
                    <li key={event.id}>
                      <div className="relative pb-8 ">
                        <div className="relative flex space-x-3 items-center">
                          <div>
                            <span
                              className={classNames(
                                event.iconBackground,
                                "h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                              )}
                            >
                              <event.icon
                                className="h-5 w-5 text-white"
                                aria-hidden="true"
                              />
                            </span>
                          </div>
                          <div className="flex min-w-0 flex-1 justify-between space-x-4 ">
                            <div className="items-center">
                              <p className="font-medium text-gray-900 lg:w-96">
                                {event.target}
                              </p>
                            </div>
                          </div>
                        </div>
                        <ul className="ml-20 mt-5l">
                          {event.item?.split("/").map((opt) => (
                            <li key={opt} className="list-disc lg:w-2/3">
                              {opt}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="ml-20 opacity-60">
                  <p className="text-left mt-10">
                    Дэлгэрэнгүйг{" "}
                    <a
                      href="https:www.zangia.mn/"
                      target="_black"
                      rel="noopener noreferrer"
                      className="font-bold italic  underline"
                    >
                      zangia.mn
                    </a>{" "}
                    сайтын ажлын байрны зар болон доорх хаягаас:
                  </p>
                  <div className="flex gap-4">
                    <p className="">Утас: 75056010-4, 91104545</p>
                    <p className="">Майл: hr@nairamdal.mn</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
